import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  useMediaQuery,
  Box,
  Avatar,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logoMan from "../../../assets/images/logoman.png";
import WorkIcon from "@mui/icons-material/Work";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import StarIcon from "@mui/icons-material/Star";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DescriptionIcon from "@mui/icons-material/Description";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleIcon from "@mui/icons-material/People";
import Accountmenu from "../../menu/Accountmenu";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useIds } from "../../../hook/AdminContext";
import { s3baseUri, web_url } from "../../../config/config";
import { show_proper_words, sourceAccessMap } from "../../../utils/Constant";
import { ExpandMore, ExpandLess, ArrowBack } from "@mui/icons-material";
import { Icon } from "@iconify/react/dist/iconify.js";
import { get_outside_jobs_api } from "../../../DAL/TalentSourceAPI/TalentSourceApi";
import { enqueueSnackbar } from "notistack";
import UpgradeModal from "../../popUp/UpgradeModal";
import SkeletonLoader from "../../loader/SkeletonLoader";
import PostJobHeader from "../../../pages/post/PostJobHeader";
import { get_jobs_list } from "../../../DAL/jobs/jobs";
import { HomeIcon, noImagePlaceholder, portal_logo } from "../../../assets";
import { icon_1 } from "../../../assets";
import CustomModalLayout from "../../modal/CustomModalLayout";

const Sidebar = ({
  currentSidebar,
  shouldHideSidebar = false,
  drawerOpen,
  setDrawerOpen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [drawerHeight, setDrawerHeight] = useState(900);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sourceId, setsourceId] = useState(null);
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [partnersObj, setPartnersObj] = useState({});
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const load_more_path = "api/jobs/list?page=0&limit=50";

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const { activeSourceList, userInfo, findId, userAPIData, sideBarLoading } =
    useIds();

  const { pathname } = location;
  const firstSegment = location.pathname.split("/")[1];

  const handleNavigate = () => {
    navigate("/favourite-jobs");
  };

  const openAccount = Boolean(anchorEl);

  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.screen.width; // resolution
      const zoom = window.devicePixelRatio || 1;

      const baseHeight = 600;
      const maxExtra = 300;

      const resolutionFactor = (1920 - screenWidth) / 1920; // e.g. 1366 → 0.28
      const zoomFactor = (zoom - 1) * 200;

      let totalHeight = baseHeight + resolutionFactor * maxExtra + zoomFactor;
      totalHeight = Math.min(totalHeight, 900); // optional max cap

      setDrawerHeight(totalHeight);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [drawerHeight]);

  const handleSummarizeClick = () => {
    const path = `/my-job-posts`;
    navigate(path || "/home");
  };
  const handleOpen = () => {
    if (
      (userInfo?.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo?.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }

    setOpen(true);
    setEditMode(false);
  };
  const handleCloseJobPanel = () => {
    setOpen(false);
  };

  const fetchCategories = async (path, search, loading, id) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (firstSegment === "home") {
      id = "";
    } else {
      id = localStorage.getItem("source_id") || findId;
    }

    const response = await get_jobs_list(0, 50, "");

    for (let i = 0; i < response.jobs?.length; i++) {
      for (let j = 0; j < response.jobs[i].job_applicants.length; j++) {
        if (
          userInfo?.user_id?._id === response.jobs[i]?.job_applicants[j]?.userId
        ) {
          response.jobs[i].created_by_me = true;
        }
      }
    }

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);

      if (loading) {
        let new_array = categories.concat(response.jobs);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        setPageNumber(1);
      }

      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const handleFeatureSidebar = () => {
    const dynamicRouteSlugs = [
      //static rourtes k liye
      "clients",
      "industry-partner",
      "industry-supplier",
      "agency-partner",
    ];

    const featureRouteSlugs = [
      "hr",
      "HR",
      "interview",
      "Interview",
      "training-source",
      "mindset-source",
      "job-description",
      "temping",
      "Temping",
      "new",
      "leaders-in-the-industry",
      "Leaders-In-The-Industry",
      "leaders",
    ];

    // Alternative: Check by ID (uncomment if you prefer ID-based checking)
    // const dynamicRouteIds = [
    //   "68242b7c25684254f8c1be4c", // Clients
    //   "68242be925684254f8c1be54", // Industry Suppliers
    //   "68242b6825684254f8c1be4a", // Industry Partners
    //   "68242b4e25684254f8c1be48", // Agency Partners
    // ];

    // if (userInfo?.type === 1) {
    const desiredOrder = [
      "68242ab625684254f8c1be40", // Leaders In The Industry
      "68242a7825684254f8c1be3e", // Interview
      "68242acb25684254f8c1be42", // HR
      "68242ae625684254f8c1be44", // Training Source
      "68242b7c25684254f8c1be4c", // Clients
      "68242b6825684254f8c1be4a", // Industry Partners
      "68242be925684254f8c1be54", // Industry Suppliers
      "68242b4e25684254f8c1be48", // Agency Partners
      "68242b3725684254f8c1be46", // Mindset Source
      "68242b9a25684254f8c1be4e", // Job Description
      "68242bcb25684254f8c1be52", // Temping
      "68242bb225684254f8c1be50", // Live Job Feed
    ];

    // const sortedItems = [...item].sort((a, b) => {
    //   return desiredOrder.indexOf(a._id) - desiredOrder.indexOf(b._id);
    // });

    const featuresList = userAPIData?.navbar.find(
      (obj) => obj.source_slug == firstSegment
    )?.features;

    if (!featuresList) return;
    const matchedItems = featuresList.map((section) => {
      return {
        text: section.title,
        path:
          section.type == "client_type"
            ? `/${firstSegment}/type/${section.slug}`
            : section.type == "job"
            ? `/${firstSegment}/${section.slug}`
            : `/${firstSegment}/feature/${section.slug}`,
        icon: section.icon_image?.thumbnail_1
          ? s3baseUri + section.icon_image?.thumbnail_1
          : "",
        _id: section._id,
      };
    });

    return [
      {
        text: `${show_proper_words(firstSegment)} Home`,
        path: `${firstSegment}/home`,
        icon: <img src={icon_1}></img>,
        _id: "21288cbdhuxgvs5rfgvbs1", // Use first id if available
      },
      ...matchedItems,
    ];
  };

  const sidebarData = () => {
    const homeItem = {
      text: "Home",
      icon: <img src={icon_1} alt="" />,
      path: "/home",
      _id: userAPIData?.navbar[0]?._id || "",
    };

    const SideData = userAPIData?.navbar;

    let dynamicItems = [];

    if (SideData?.length > 0) {
      dynamicItems = SideData?.map((item) => ({
        text: item.title,
        path: `/${item.source_slug}/home`,
        icon: item.icon_image?.thumbnail_1
          ? s3baseUri + item.icon_image?.thumbnail_1
          : "",
        _id: item._id,
      }));
    }

    return [homeItem, ...dynamicItems];
  };

  let sideBar =
    currentSidebar === "main"
      ? sidebarData()
      : handleFeatureSidebar()
      ? handleFeatureSidebar()
      : sidebarData();

  const smartBack = () => {
    navigate(-1);
  };

  const showBackButton = pathname !== "/dashboard" && pathname !== "/home";
  const iconColor = "var(--portal-primary-color)";

  console.log(sideBar, "--sideBar");

  const sidebarContent = (
    <List
      className="sidebar-menu card-1"
      sx={
        {
          // zoom effect change
          // minHeight: `calc(107vh - 60px)`,
        }
      }
    >
      {!sideBarLoading && sideBar?.length > 0 ? (
        sideBar.map((item, index) => {
          const isHome = item.text.endsWith("Home");
          const isActive =
            (isHome && `/${firstSegment}/home` === location.pathname) ||
            location.pathname === item.path ||
            (location.pathname.startsWith(`${item.path}/`) &&
              item.path.split("/").length > 2);

          return (
            <ListItem
              className={`menu-item  ${isActive ? "active" : ""}`}
              key={index}
              button
              component={Link}
              to={item.path}
              onClick={() => {
                navigate(item.path);
                if (item._id && currentSidebar === "main") {
                  localStorage.setItem("source_id", item._id);
                }
              }}
            >
              <div className="sidebar-menu-icon">
                {typeof item.icon === "string" ? (
                  <img src={item.icon} />
                ) : (
                  item.icon
                )}
              </div>
              <ListItemText primary={item.text} className="menu-text" />
            </ListItem>
          );
        })
      ) : (
        <SkeletonLoader height={40} />
      )}
    </List>
  );

  return (
    <>
      <UpgradeModal
        open={openUpgradeModal}
        handleClose={() => setOpenUpgradeModal(false)}
      />

      <CustomModalLayout
        open={open}
        onClose={handleCloseJobPanel}
        title={editMode ? "Update Job" : "Post Job"}
        width="850px"
        componentToPass={
          <PostJobHeader
            refreshlist={fetchCategories}
            loadMorePath={load_more_path}
            searchTerm={searchTerm}
            loadingstate={loading}
            id={findId || localStorage.getItem("source_id")}
            open={open}
            handleClose={handleCloseJobPanel}
            editMode={editMode}
            jobData={selectedJob}
            sourceId={sourceId}
          />
        }
      />

      {isSmallScreen && (
        <AppBar
          className="app-header mobile-screen-header"
          position="fixed"
          sx={{ bgcolor: "#fff", zIndex: 1200 }}
        >
          <Toolbar
            sx={{
              minHeight: "61px !important",
              display: "flex",
              justifyContent: "space-between",
              overflow: "hidden",
              px: 1,
              gap: 1,
            }}
          >
            {/* Left Section - Menu and Back Button */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: 0,
              }}
            >
              {showBackButton && (
                <Tooltip title="Go Back">
                  <IconButton
                    onClick={smartBack}
                    size="small"
                    sx={{
                      color: iconColor,
                      animation: "bounceLeftRight 1s infinite",
                      "&:hover": { animation: "none" },
                      p: 0.5,
                    }}
                  >
                    <ArrowBack fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              {!shouldHideSidebar && (
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setDrawerOpen(true)}
                  sx={{ color: "var(--portal-primary-color)", p: 0.5 }}
                  size="small"
                >
                  <MenuIcon fontSize="small" />
                </IconButton>
              )}
            </Box>

            {/* Right Section - Icons and Avatar */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { xs: 0.5, sm: 1 },
                minWidth: 0,
              }}
            >
              {/* Favorite/Job Posting Icons */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& .MuiTypography-body2": {
                    display: { xs: "none", sm: "block" },
                  },
                }}
              >
                {Array.isArray(userInfo?.source) &&
                  userInfo?.role === "candidate" &&
                  userInfo?.source.length > 0 &&
                  !userInfo?.isCompanyProfile && (
                    <Tooltip title="View Favorite Jobs">
                      <IconButton
                        onClick={handleNavigate}
                        size="small"
                        sx={{ p: 0.5, color: "var(--portal-primary-color)" }}
                      >
                        <BookmarkIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}

                {((userInfo?.role === "client" &&
                  !userInfo?.isCompanyProfile) ||
                  (userInfo?.isCompanyProfile &&
                    userInfo?.company_access?.job?.add)) && (
                  <>
                    <Tooltip title="Post Job">
                      <IconButton
                        size="small"
                        sx={{ p: 0.1, color: "var(--portal-primary-color)" }}
                        onClick={handleOpen}
                      >
                        <Icon icon="ic:round-post-add" width={22} height={22} />
                      </IconButton>
                    </Tooltip>

                    {/* Vertical separator line */}
                    <Box
                      sx={{
                        height: "20px",
                        width: "1px",
                        backgroundColor: "rgba(0, 0, 0, 0.12)",
                        mx: 0.1,
                        my: "auto",
                      }}
                    />
                  </>
                )}

                {(userInfo?.role === "client" ||
                  userInfo?.isCompanyProfile) && (
                  <Tooltip title="My Job Posts">
                    <IconButton
                      size="small"
                      sx={{ p: 0.5, color: "var(--portal-primary-color)" }}
                      onClick={handleSummarizeClick}
                    >
                      <Icon
                        icon="streamline-flex:search-category-remix"
                        width={16}
                        height={16}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>

              {/* Avatar with Dropdown */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  ml: 0.5,
                }}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <Box sx={{ position: "relative" }}>
                  <Avatar
                    src={
                      s3baseUri +
                      userInfo?.company_profile?.profile_image?.thumbnail_1
                    }
                    sx={{
                      width: 32,
                      height: 32,
                      border: "none",
                    }}
                  />
                  {openAccount ? (
                    <ExpandLess
                      sx={{
                        position: "absolute",
                        bottom: -4,
                        right: -4,
                        fontSize: "14px",

                        color:
                          (userInfo?.role === "client" &&
                            userInfo?.has_pending_requests &&
                            !userInfo?.isCompanyProfile) ||
                          (userInfo?.user_invitaion_status &&
                            !userInfo?.isCompanyProfile) ||
                          ((userInfo?.direct_contact_check ||
                            userInfo?.has_pending_affiliation_request) &&
                            !userInfo?.isCompanyProfile) ||
                          (userInfo?.isCompanyProfile &&
                            userInfo?.company_access?.manage_profile
                              ?.company_profile &&
                            (userInfo?.direct_contact_check ||
                              userInfo?.has_pending_affiliation_request))
                            ? "#fff"
                            : "var(--portal-primary-color)",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <ExpandMore
                      sx={{
                        position: "absolute",
                        bottom: -4,
                        right: -4,
                        fontSize: "14px",
                        backgroundColor:
                          (userInfo?.role === "client" &&
                            userInfo?.has_pending_requests &&
                            !userInfo?.isCompanyProfile) ||
                          (userInfo?.user_invitaion_status &&
                            !userInfo?.isCompanyProfile) ||
                          ((userInfo?.direct_contact_check ||
                            userInfo?.has_pending_affiliation_request) &&
                            !userInfo?.isCompanyProfile) ||
                          (userInfo?.isCompanyProfile &&
                            userInfo?.company_access?.manage_profile
                              ?.company_profile &&
                            (userInfo?.direct_contact_check ||
                              userInfo?.has_pending_affiliation_request))
                            ? "red"
                            : "white",
                        borderRadius: "50%",
                        color:
                          (userInfo?.role === "client" &&
                            userInfo?.has_pending_requests &&
                            !userInfo?.isCompanyProfile) ||
                          (userInfo?.user_invitaion_status &&
                            !userInfo?.isCompanyProfile) ||
                          ((userInfo?.direct_contact_check ||
                            userInfo?.has_pending_affiliation_request) &&
                            !userInfo?.isCompanyProfile) ||
                          (userInfo?.isCompanyProfile &&
                            userInfo?.company_access?.manage_profile
                              ?.company_profile &&
                            (userInfo?.direct_contact_check ||
                              userInfo?.has_pending_affiliation_request))
                            ? "#fff"
                            : "var(--portal-primary-color)",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Box>

            <Accountmenu
              anchorEl={anchorEl}
              open={openAccount}
              handleClose={handleClose}
            />
          </Toolbar>
        </AppBar>
      )}
      {!shouldHideSidebar && (
        <Drawer
          className="app-sidebar left-sidebar"
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          variant={isSmallScreen ? "temporary" : "permanent"}
          sx={{
            zIndex: 1300,
            "& .MuiDrawer-paper": {
              width: isSmallScreen ? "80%" : 300,
              maxWidth: "400px",
              height: "100%",
              transition: "all 0.3s ease",
              position: isSmallScreen ? "fiexed" : "inherit",
            },
          }}
        >
          <Box
            className="no-scrollbar pb-3 px-2"
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              px: 0,
            }}
            onClick={() => {
              if (isSmallScreen) setDrawerOpen(false);
            }}
          >
            {isSmallScreen && (
              <div className="px-3 pt-3 pb-3 border-bottom d-flex align-items-center justify-content-between">
                <img
                  src={portal_logo}
                  alt="Logo"
                  style={{ width: "150px", cursor: "pointer" }}
                />

                <div>
                  {" "}
                  <Icon
                    onClick={() => {
                      setDrawerOpen(false);
                    }}
                    className="sidebar-icon"
                    icon="maki:cross"
                    width="20"
                  />
                </div>
              </div>
            )}
            {sidebarContent}
            <div className="portal-links mt-0 mt-lg-2 pt-1 pt-lg-3">
              <ul>
                <li>
                  <a href={`${web_url}/privacy-policy`} target="_blank">
                    Privacy
                  </a>
                </li>
                <li>
                  <a href={`${web_url}/terms-and-conditions`} target="_blank">
                    Terms
                  </a>
                </li>
                <li>
                  <a href={`${web_url}/about-us`} target="_blank">
                    About
                  </a>
                </li>
                <li>
                  <a href={`${web_url}/contact-us`} target="_blank">
                    Help
                  </a>
                </li>
              </ul>
            </div>
          </Box>
        </Drawer>
      )}
    </>
  );
};

export default Sidebar;
